import { Input } from '@angular/core';

export abstract class VrRadioButton {
  @Input() value!: any;
  @Input() disabled = false;
  content?: any;
}
